import { map621ToConfigurationData } from 'legacy/lut/services/partner360/configuration/mappings/map621ToConfigurationData'
import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { setAvailableCurrencies } from '../configurationSlice'
import { partnerDataFulfilled } from '../partnerDataLifecycle'

listenerMiddleware.startListening({
  actionCreator: partnerDataFulfilled,
  effect: (action, { dispatch }) => {
    const mappedConfiguration = map621ToConfigurationData(action.payload)

    const selectedValue =
      mappedConfiguration.currencyData.localCurrency ||
      mappedConfiguration.currencyData.defaultCurrency

    const currencies = ['USD']
    if (selectedValue && !currencies.includes(selectedValue)) {
      currencies.push(selectedValue)
    }

    dispatch(setAvailableCurrencies(currencies))
  },
})
